import colors from './colors'

const selectStyle = {
  '&.MuiSelect-outlined , .MuiOutlinedInput-input': {
    p: '.8rem',
    marginTop: 0,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.WHITE,
  },
  '&.MuiSelect-root , .MuiSelect-icon': {
    top: 'auto !important',
    right: '1.2rem',
  },
  minWidth: '16rem',
  width: '100%',
  height: '100%',
  borderRadius: '.5rem',
  border: `1px solid ${colors.TAG_LINES_GRAY}`,
  justifyContent: 'center',
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}

const textAreaStyle = {
  minWidth: '100%',
  maxWidth: '100%',
  borderRadius: '5px',
  padding: '1rem',
  // marginTop: '1.6rem',
  borderColor: colors.TAG_LINES_GRAY,
  fontFamily: 'Aktiv Grotesk, sans-serif',
  fontSize: '14px',
  '@media (minWidth:1920px)': {
    fontSize: '18px',
  },
}

const numberInputStyle = {
  minWidth: '100%',
  maxWidth: '100%',
  borderRadius: '5px',
  marginTop: '1rem',
  borderColor: colors.TAG_LINES_GRAY,
  fontFamily: 'Aktiv Grotesk, sans-serif',
  fontSize: '14px',
  '@media (minWidth:1920px)': {
    fontSize: '18px',
  },
  '.MuiOutlinedInput-input': {
    padding: '1rem',
  },
}

export { selectStyle, textAreaStyle, numberInputStyle }
